module.exports = __webpack_public_path__ + "img/CoolBar.c4a7c189.png";